import * as React from "react"
import * as styles from "./styles.css"

// this route wraps all `site/:siteId/data-layer/` routes
export function DataLayerRoot({ children }: { children: React.ReactNode }) {
  return <div className={styles.root}>{children}</div>
}
